import styled from 'styled-components';
import { breakpoints, colors } from '../../../theme';

const DashboardHeaderStyled = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 24px;
    @media screen and (max-width: ${breakpoints.s}) {
        flex-direction: column;
    }
    @media print {
        padding-bottom: 5px;
        break-after: avoid;
    }
`;
export const ButtonContainer = styled.div`
    display: flex;
    box-sizing: border-box;
    gap: 8px;
    justify-content: space-around;
    align-items: center;
`;

export const NoPrintWrapper = styled.div`
    @media print {
        display: none;
    }
`;

export const ModeToggleContainer = styled.div`
    display: flex;
    align-items: center;
    border-radius: 8px;
    background: ${colors.grey700};
    padding: 2px;
    @media print {
        display: none;
    }
`;

interface ModeToggleButtonProps {
    $active: boolean;
}

export const ModeToggleButton = styled.button(({ $active }: ModeToggleButtonProps) => `
    border: none;
    border-radius: 8px;
    padding: 12px;
    cursor: pointer;
    background: ${$active ? colors.grey000 : 'transparent'};
    color: ${$active ? colors.grey300 : colors.grey400};
    font-size: 13px;
    font-weight: ${$active ? 600 : 400};
    box-shadow: ${$active ? '0 1px 2px rgba(0,0,0,0.12)' : 'none'};
    transition: all 0.15s ease;
    white-space: nowrap;
    line-height: 1.4;
    font-family: Barlow;
    font-size: 16px;
`);

export default DashboardHeaderStyled;
